// TEMPORARY web33 experiment. Teardown: delete this folder and remove its
// App.tsx, chart, analytics, debug, style, and version call sites.

import { locHtml } from "../../static/locHtml";

const pathTakingShapeSplashElement = {
  name: "path-taking-shape-splash",
  type: "html",
  html: locHtml((t) => `
    <div class="web33-path-splash">
      <h1>${t("splash.openingArc.pathTakingShape.title")}</h1>
      <div class="web33-path-splash__card">
        <div class="web33-path-splash__item">
          <span class="web33-path-splash__icon" aria-hidden="true">🎯</span>
          <p>${t("splash.openingArc.pathTakingShape.targets")}</p>
        </div>
        <div class="web33-path-splash__item">
          <span class="web33-path-splash__icon" aria-hidden="true">📈</span>
          <p>${t("splash.openingArc.pathTakingShape.recalibrates")}</p>
        </div>
        <div class="web33-path-splash__item">
          <span class="web33-path-splash__icon" aria-hidden="true">⏱</span>
          <p>${t("splash.openingArc.pathTakingShape.adjusts")}</p>
        </div>
      </div>
      <p class="web33-path-splash__support">${t("splash.openingArc.pathTakingShape.support")}</p>
    </div>
  `),
};

export { pathTakingShapeSplashElement };
